import { Component, OnInit } from '@angular/core';
import { LoaderService } from '../../logic/services/loader.service';

@Component({
  selector: 'loading-overlay',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {
  loading: boolean;

  constructor(private loaderService: LoaderService) { }

  ngOnInit() {
    this.loaderService.isLoading.subscribe((v) => {
      this.loading = v;
    });
  }

}